<template>
	<div>
		<select-company-component v-if="!canAccessDashboard"></select-company-component>

		<div v-if="go && canAccessDashboard">
			<client-dashboard-nav-component v-if="user === 'client'"></client-dashboard-nav-component>

			<router-view></router-view>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		const {query} = this.$route
		const go = !("intended" in query)

		return {
			user: this.$store.getters.user.type,
			go,
		};
	},
	computed: {
		canAccessDashboard() {
			if (this.user === 'back-office') {
				return true;
			}

			return !_.isEmpty(this.$store.getters.company);
		},
	},
	watch: {
		canAccessDashboard: function (value) {
			if (value) {
				const { query } = this.$route

				if ('intended' in query) {
					window.location = query.intended;
					return
				}

				this.go = true
			}
		}
	},
};
</script>
